<template lang="pug">
    div.dashboard

        // Header
        header-component(:menu="$t('dashboard.navigation')" dashboard)

        v-container.mt-5
            v-row
                v-col
                    // Description
                    div.title
                        slot(name="title")

                    v-divider.my-5

                    // Content
                    v-card.dashboardContent.pa-4(elevation="1")
                        slot

        // Footer
        footer-component
</template>

<script>
    import VueTypes from 'vue-types';
    import { Header } from '~components';
    import Footer from '../../Footer';

    export default {
        components: {
            HeaderComponent: Header,
            FooterComponent: Footer,
        },
        props: {
            page: VueTypes.string.def(''),
        },
    };
</script>

<style lang="stylus" scoped>
    @import "../../../assets/style/_variables.styl"

    .dashboard
        padding: 60px 0
        color: $theme.black

    .dashboardContent
        min-height: calc(100vh - 280px)
</style>
